export default __webpack_public_path__ + "static/media/news3.ff6d357b.png";